import { useSelector } from 'react-redux'

import { RootState } from '../store'

const useNotificationStateSelector = () =>
  useSelector((state: RootState) => state.commonModel.notificationState)

export { useNotificationStateSelector }
